import Panel from "./panel";
import PanelExpandableContent from "./panel-expandable-content";
import PanelTakeover from "./panel-takeover";
Panel.ExpandableContent = PanelExpandableContent;
Panel.Takeover = PanelTakeover;
export default Panel;
//# sourceMappingURL=index.js.map